import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ConfirmationDialogComponent } from '@common/confirmation-dialog/confirmation-dialog.component';
import { commonImages } from '@images/common-images';
import { propertyImages } from '@images/property-images';
import { DashService } from '@modules/dash-board/dash.service';
import { ApiService } from '@services/api/api.service';
import { HistoryService } from '@services/api/history.service';
import { PropertyService } from '@services/api/property.service';
import { TaskService } from '@services/api/task.service';
import { WorkflowService } from '@services/api/workflow.service';
import { AuthService } from '@services/auth.service';
import { Crypto } from '@services/helpers/encryption-utils';
import { FormHelper } from '@services/helpers/form-helper';
import { LocalStorageService } from '@services/helpers/local-storage.service';
import { Utils } from '@services/helpers/utils';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { MessageService } from '@services/util/message.service';
import { ReduxService } from '@state-management/redux.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { RemmiConfirmService } from '@common/remmi-confirm/remmi-confirm.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListingService } from '../../listing-service';

class manualHistory {
  property_status: string;
  buyer: any[] = [];
  seller: any[] = [];
  date: Date;
  agent: string;
  price: string;
}
class appraisalForm {
  appraisal_Date: Date;
  price_guide: string;
  agent: any[] = [];
  appraisal_status: any[] = [];
  owner: any[] = [];
  lead_source: any[] = [];
  notes: string;
}
interface itemData {
  activeIndex: number;
  id: number;
  name: string;
}
@Component({
  selector: 'app-add-properties',
  templateUrl: './add-properties.component.html',
  styleUrls: ['./add-properties.component.scss'],
})
export class AddPropertiesComponent implements OnInit {
  @ViewChild('ops') ops!: OverlayPanel;

  @ViewChild('listingDetailDialog') listingDetailDialog: ConfirmationDialogComponent;
  @ViewChild('manualCurrentDetailDialog') manualCurrentDetailDialog: ConfirmationDialogComponent;
  @ViewChild('listingHistoriesDialog') listingHistoriesDialog: ConfirmationDialogComponent;
  @ViewChild('manualDetailDialog') manualDetailDialog: ConfirmationDialogComponent;

  @Input() create_contact: Observable<any> = null;
  @Input() updated_contact: Observable<any> = null;
  @Input() property_id: any;
  @Input() TaskUpdatedStatus: Observable<any> = null;
  @Output() renderPropertyList = new EventEmitter<boolean>();
  @Output() property_close = new EventEmitter<any>();
  @Output() propertyId = new EventEmitter<any>();
  @Output() refreshProperty = new EventEmitter<boolean>();

  formalFields: { name: string; label: string }[] = [];
  moment: any = moment;
  S3Path = environment.S3 + '/';
  images = propertyImages;
  common_images = commonImages;

  manualHistory: manualHistory = new manualHistory();
  appraisal: appraisalForm = new appraisalForm();
  manualGenerateHistory: boolean = false;
  isDocuments: boolean = false;
  isAppraisal: boolean = false;
  public user_role = Crypto.decrypt(this.localStorageService.GetItem('role'));
  view = 'add_listing_property';
  properties: any;
  filteredItems = [];
  selectedProperty: any;
  submitDisable: boolean = false;
  editProperty: FormGroup;
  disableAddListing = true;
  AuthUser: any;
  user_permission: any;
  submitted: boolean = false;
  notDisplayRequiredMessage = true;
  requiredErrorMessages = [];
  controls: { [key: string]: { control: AbstractControl; tabIndex: number; elementRef: ElementRef } } = {};
  numOfNotValidFields: number = 0;
  previousOwner = [];
  landSpecialError: boolean = false;
  buildingSpecialError: boolean = false;
  newContact = null;
  minDated = new Date();
  isMobileDevice: boolean = false;
  selected_menu = null;
  rows: number = 15;
  page: number = 1;
  isLoading: boolean = true;
  scrollTop: number = 0;
  options = { componentRestrictions: { country: 'AU' }, types: ['geocode'] };
  public Editor = ClassicEditor;

  // ------------------
  constructor(
    private localStorageService: LocalStorageService,
    public lmService: LeadManagementService,
    private fb: FormBuilder,
    private api: ApiService,
    private formHelper: FormHelper,
    private toast: ToastrService,
    private Auth: AuthService,
    private _workflowService: WorkflowService,
    private remmiConfirm: RemmiConfirmService,
    private elemRef: ElementRef,
    private dash: DashService,
    private router: Router,
    private route: ActivatedRoute,
    public listingService: ListingService,
    private _propertyService: PropertyService,
    private _historyService: HistoryService,
    private _taskService: TaskService,
    private redux: ReduxService,
    private message: MessageService
  ) {
    this.editProperty = this.fb.group({
      property_address: ['', Validators.required],
      isHideAddress: [false],
      building_name: [''],
      unit_no: [''],
      street_no: [''],
      street_name: [''],
      suburb: [''],
      state: [''],
      post_code: [''],

      country: [''],
      latitude: [''],
      longitude: [''],
      type: ['', Validators.required],
      beds: [''],
      baths: [''],
      ensuite: [''],
      car: [''],
      pools: [''],
      study: [''],
      garage: [''],
      car_port: [''],
      year_built: [''],
      living_areas: [''],
      open_spaces: [''],
      heading: [''],
      description_garax: [''],
      land_area: [''],
      land_area_type: [this.listingService.listingPropertyOption.land_building_area_type[0]],
      building_area: [''],
      building_area_type: [this.listingService.listingPropertyOption.land_building_area_type[0]],
      features: [null],
      exterior: [''],
      roofing: [''],
      energy_rating: [''],
      views: [''],
      office_id: [''],
    });

    this.controls = {
      property_address: { control: this.editProperty.get('property_address'), tabIndex: 0, elementRef: this.elemRef },
      isHideAddress: { control: this.editProperty.get('isHideAddress'), tabIndex: 0, elementRef: this.elemRef },
      building_name: { control: this.editProperty.get('building_name'), tabIndex: 0, elementRef: this.elemRef },
      unit_no: { control: this.editProperty.get('unit_no'), tabIndex: 0, elementRef: this.elemRef },
      street_no: { control: this.editProperty.get('street_no'), tabIndex: 0, elementRef: this.elemRef },
      street_name: { control: this.editProperty.get('street_name'), tabIndex: 0, elementRef: this.elemRef },
      suburb: { control: this.editProperty.get('suburb'), tabIndex: 0, elementRef: this.elemRef },
      state: { control: this.editProperty.get('state'), tabIndex: 0, elementRef: this.elemRef },
      post_code: { control: this.editProperty.get('post_code'), tabIndex: 0, elementRef: this.elemRef },
      country: { control: this.editProperty.get('country'), tabIndex: 0, elementRef: this.elemRef },
      type: { control: this.editProperty.get('type'), tabIndex: 0, elementRef: this.elemRef },
      beds: { control: this.editProperty.get('beds'), tabIndex: 0, elementRef: this.elemRef },
      baths: { control: this.editProperty.get('baths'), tabIndex: 0, elementRef: this.elemRef },
      ensuite: { control: this.editProperty.get('ensuite'), tabIndex: 0, elementRef: this.elemRef },
      car: { control: this.editProperty.get('car'), tabIndex: 0, elementRef: this.elemRef },
      pools: { control: this.editProperty.get('pools'), tabIndex: 0, elementRef: this.elemRef },
      garage: { control: this.editProperty.get('garage'), tabIndex: 0, elementRef: this.elemRef },
      car_port: { control: this.editProperty.get('car_port'), tabIndex: 0, elementRef: this.elemRef },

      year_built: { control: this.editProperty.get('year_built'), tabIndex: 0, elementRef: this.elemRef },
      living_areas: { control: this.editProperty.get('living_areas'), tabIndex: 0, elementRef: this.elemRef },
      open_spaces: { control: this.editProperty.get('open_spaces'), tabIndex: 0, elementRef: this.elemRef },
      heading: { control: this.editProperty.get('heading'), tabIndex: 0, elementRef: this.elemRef },
      description_garax: { control: this.editProperty.get('description_garax'), tabIndex: 0, elementRef: this.elemRef },
      land_area: { control: this.editProperty.get('land_area'), tabIndex: 0, elementRef: this.elemRef },
      land_area_type: { control: this.editProperty.get('land_area_type'), tabIndex: 0, elementRef: this.elemRef },
      building_area: { control: this.editProperty.get('building_area'), tabIndex: 0, elementRef: this.elemRef },

      building_area_type: { control: this.editProperty.get('building_area_type'), tabIndex: 0, elementRef: this.elemRef },

      features: { control: this.editProperty.get('features'), tabIndex: 0, elementRef: this.elemRef },
      exterior: { control: this.editProperty.get('exterior'), tabIndex: 0, elementRef: this.elemRef },
      roofing: { control: this.editProperty.get('roofing'), tabIndex: 0, elementRef: this.elemRef },
      energy_rating: { control: this.editProperty.get('energy_rating'), tabIndex: 0, elementRef: this.elemRef },
      views: { control: this.editProperty.get('views'), tabIndex: 0, elementRef: this.elemRef },
      office_id: { control: this.editProperty.get('office_id'), tabIndex: 0, elementRef: this.elemRef },
    };
  }

  ngOnInit(): void {
    this.TaskUpdatedStatus?.subscribe(res => {
      if (res) {
        this.getTasks();
      }
    });

    this.property_id !== 'createnew' && this.existEditProperty();

    this.listingService.getTags();
    this.listingService.getPropertyFeatures();
    this.getProperty();
    this.user_permission = Crypto.decrypt(this.localStorageService.GetItem('_per'));
    this.Auth.UserSub.subscribe(user => {
      this.AuthUser = user;
    });
    this.updated_contact?.subscribe(() => {
      this.lmService.getShortContacts();
    });

    if (this.lmService.property_show_div == 'add_property') {
      this.editProperty.reset();
      this.selectedProperty = null;
      this.property_id = null;
      this.editProperty.patchValue({
        building_area_type: this.listingService.listingPropertyOption.land_building_area_type[0]['name'],
        land_area_type: this.listingService.listingPropertyOption.land_building_area_type[0]['name'],
      });
    } else {
      let isCache = this.localStorageService.GetItem('isPropCache');
      let cacheIds;
      if (isCache !== null && isCache !== undefined) {
        cacheIds = Crypto.decrypt(isCache);
        cacheIds.forEach((ele, idx) => {
          if (ele === this.property_id) {
            this.isCache = false;
            cacheIds.splice(idx, 1);
            this.localStorageService.SetItem('isPropCache', Crypto.encrypt(cacheIds));
          }
        });
      }
    }

    this.create_contact?.subscribe(rex => {
      if (rex) {
        if (this.newContact == 'current_owner') {
          this.manualHistory.buyer = this.manualHistory.buyer == null ? [rex] : [...this.manualHistory.buyer, rex];
        } else if (this.newContact == 'previous_owner') {
          this.manualHistory.seller = this.manualHistory.seller == null ? [rex] : [...this.manualHistory.seller, rex];
        } else if (this.newContact == 'appraisal_contact') {
          this.appraisal.owner = this.appraisal.owner == null ? [rex] : [...this.appraisal.owner, rex];
        }
      }
    });

    this.dash?.screenSize$?.subscribe(size => {
      if (size.width < 600) {
        this.isMobileDevice = true;
      } else {
        this.isMobileDevice = false;
      }
    });
  }
  onReadyDes(editor) {
    editor.ui.getEditableElement().parentElement.insertBefore(editor.ui.view.toolbar.element, editor.ui.getEditableElement());
  }
  originalAssigns: any[] = [];
  getAgents() {
    /**
     * Fetches the list of active staff members from the API and assigns them to the `originalAssigns` and `originalAssignsAppt` variables.
     *
     * The API call is cached and will only be made if the data is not already cached.
     *
     * If the `listing_show_div` value in the `lmService` is set to "add_listing_from_property", "add_listing_property" or "add_listing_property_listing",
     * the function will filter out the deactivated staff members.
     *
     * The response data is mapped to a new array of objects with a `full_name` property that is created by concatenating the `first_name` and `last_name`.
     * The array is then sorted alphabetically by `full_name`.
     *
     * The `originalAssignsAppt` variable is assigned the combined array of active staff members and the short contact company list from the `lmService`.
     */
    let url = '/users/byoffice?office=' + this.api.getOfficeId() + '&show=staff';
    this.redux.getSetProjectInfo(false, 'byOffice', url).subscribe({
      next: response => {
        // Maps the retrieved staff data and constructs the full name
        let active_staff = JSON.parse(JSON.stringify(response.data));
        this.originalAssigns = active_staff
          ?.filter(el => el?.deactive !== true)
          ?.map(i => {
            i.full_name = i.first_name + ' ' + i.last_name;
            return i;
          })
          .sort((a, b) => a?.full_name.localeCompare(b?.full_name));
      },
    });
  }

  listingGlobalItem: any;
  globalItemContact: any[] = [];
  openListingDetailModal(status) {
    this.listingDetailDialog.show();
    this.listingGlobalItem = status;
    this.globalItemContact = this.listingGlobalItem?.listing_contacts?.filter(x => x?.is_settlement === true);
  }

  manualGlobalItem: any;
  openManualCurrentDetail(item) {
    this.manualCurrentDetailDialog.show();
    this.manualGlobalItem = item;
  }

  filterItems(event) {
    let query = event.query;
    this._propertyService.getSuburb(query).subscribe({
      next: response => {
        this.filteredItems = [];
        this.filteredItems = response?.data;
      },
    });
  }

  patchEditForm() {
    // Iterate through each form control in `editProperty`
    Object.keys(this.editProperty.controls).forEach(key => {
      // Check if the key exists in `selectedProperty`, except "date" and "tags"
      if (key !== 'date' && key !== 'tags' && this.selectedProperty?.hasOwnProperty(key)) {
        this.editProperty.controls[key].setValue(this.selectedProperty[key] !== null ? this.selectedProperty[key] : null);

        // Special handling for "date" field, converting it into a Date object
      } else if (key === 'date') {
        this.editProperty.controls[key].setValue(this.selectedProperty[key] !== null ? new Date(this.selectedProperty[key]) : null);
      }
    });

    // Handle case where `building_name` is explicitly set as a string "null"
    let building_name = this.editProperty.get('building_name').value;

    // Clean up the value
    if (typeof building_name === 'string') {
      building_name = building_name.trim().replace(/"+/g, ''); // remove all quotes
    }

    // If after cleaning it's empty or equals 'null', make it truly empty
    if (!building_name || building_name.toLowerCase() === 'null') {
      this.editProperty.controls['building_name'].setValue('');
    }

    // Records saved before the latitude/longitude fields existed only carry coordinates on the suburb object
    const suburb = this.editProperty.get('suburb').value;
    if (suburb?.lat && !this.editProperty.get('latitude').value) {
      this.editProperty.controls['latitude'].setValue(suburb.lat);
    }
    if (suburb?.lng && !this.editProperty.get('longitude').value) {
      this.editProperty.controls['longitude'].setValue(suburb.lng);
    }
  }

  listingProperty: any;
  property_img: any[] = [];
  isCache: boolean = true;
  existEditProperty() {
    // Disable task creation flag
    if (!this.property_id?.includes('new')) {
      this.lmService.is_new_task = false;
      // Disable the submit button while fetching data
      this.submitDisable = true;

      // Fetch property details, utilizing cache if available
      this._propertyService.getPropertyById(this.property_id).subscribe(res => {
        // Store the retrieved property data
        this.selectedProperty = res['data'];
        this.listingProperty = res?.data;
        this.property_img = res?.data?.property_images;

        // Patch the form with the fetched data
        this.patchEditForm();

        // Check if any processes are running for this property
        this.checkProcessRunning(this.property_id);

        // Fetch the property’s listing history
        this.listingHistory();

        // Re-enable submit button and listing functionality after data is loaded
        this.submitDisable = false;
        this.disableAddListing = false;
      });
    }
  }

  no_process_run: boolean = false;
  checkProcessRunning(id) {
    this.api
      .get(
        `/workflow-process?office_id=${this.api.getOfficeId()}&module=${'properties_data'}&record_id=${id}&page=${1}&per_page=${10}&workflow_type=${'progress'}`
      )
      .subscribe(rex => {
        this.no_process_run = !rex?.data?.length ? true : false;
      });
  }

  GetPropertyWorkflowProcesses() {
    this._workflowService.isWorkflowProcessTabOpened = true;

    // Initialize workflow properties
    this._workflowService.ActiveProcessList = [];
    this._workflowService.processRecordId = this.property_id;
    this._workflowService.active_module_name = 'properties_data';

    // Fetch all workflow processes related to the "Property" module
    this._workflowService
      .GetAllProcessesByModule(this.property_id, this._workflowService.module_array.filter(res => res.name === 'Property')?.[0]?.module_value)
      .subscribe(response => {
        try {
          const { status, data, meta } = response;

          if (status) {
            // Check if there are any active processes
            if (!data?.length) {
              this.no_process_run = true;
              this._workflowService.module_isStop = true;
            } else {
              this.no_process_run = false;
              this._workflowService.module_isStop = false;
            }

            // Format process list with proper module names
            this._workflowService.ActiveProcessList = data?.map(result => ({
              ...result,
              module: Utils.capitalizePhrase(result?.module?.split('_')?.join(' ')?.trim() || ''),
            }));

            // Set up pagination details
            this._workflowService.centralizedProcessPagination = {
              ...this._workflowService.centralizedProcessPagination,
              per_page: 10,
              total_pages: Math.ceil(meta?.pagination?.total / 10),
              total: meta?.pagination?.total,
              numberOfRecords: this._workflowService.ActiveProcessList?.length > 10 ? 10 : this._workflowService.ActiveProcessList?.length,
            };
          } else {
            // If response is not successful, clear the active process list
            this._workflowService.ActiveProcessList = [];
          }
        } catch (error) {
          // Handle potential errors by resetting the process list
          this._workflowService.ActiveProcessList = [];
        }
      });
  }

  editRecord(record) {
    this.openRightModal(record, 'edit_contact');
  }

  openRightModal(contact, addOrEdit) {
    if (!this.insertedPropertyId && !this.property_id) {
      this.toast.error('First create property');
    } else if (addOrEdit === 'add_listing_from_property') {
      if (this.ownerId.length > 0) {
        let id = this.insertedPropertyId ? this.insertedPropertyId : this.property_id;
        this.lmService.listing_show_div = addOrEdit;
        this.lmService.addTabInLevels('Listing' + ' - ' + this.editProperty.controls['property_address'].value, id);
        this.lmService.is_new_listing = false;
        this.lmService.showRightBar = true;
        this.lmService.property_ownersIds = this.ownerId;
      } else {
        this.toast.error('Please add an owner to the property before creating a listing');
        this.manualGenerateHistory = true;
        this.errorMessage = true;
      }
    } else if (addOrEdit === 'edit_contact') {
      let id = contact?.contacts ? contact?.contacts?._id : contact?._id;
      let contacts = contact?.contacts ? contact?.contacts : contact;
      if (this.isMobileDevice == true) {
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: id } });
      } else {
        this.lmService.isEdit_show_div = addOrEdit;
        let name = contact?.name ? contact?.name : contact?.full_name || contact?.contacts?.full_name;
        this.lmService.addTabInLevels(`Contact-${name}`, id, contacts, {}, 'contact');
        this.lmService.cont_id = id;
        this.lmService.contact_showRightBar = true;
      }
    } else if (addOrEdit === 'add_contact') {
      if (this.isMobileDevice == true) {
        this.router.navigate(['/setting/office-contact'], { queryParams: { id: 'createnew' } });
      } else {
        this.lmService.contact_show_div = addOrEdit;
        this.lmService.addTabInLevels('Contact', 'createnew', null, {}, 'contact');
        this.lmService.contact_showRightBar = true;
      }
    } else if (addOrEdit === 'edit_listing_property') {
      let id = contact?.property_address ? contact?._id : contact;
      if (this.isMobileDevice == true) {
        this.router.navigate(['/listings/listing-properties'], { queryParams: { id: id } });
      } else {
        this.lmService.listing_show_div = addOrEdit;
        this.lmService.addTabInLevels('Listing', id, contact);
        this.lmService.is_new_listing = false;
        this.lmService.contact_showRightBar = true;
      }
    } else if (addOrEdit === 'add_contract') {
      setTimeout(() => {
        this.lmService.contract_show_div = addOrEdit;
        this.lmService.addTabInLevels('Contract', 'createnew', null);
        this.lmService.propertyId = this.property_id ? this.property_id : this.insertedPropertyId;
        this.lmService.contractId = null;
        this.lmService.contact_showRightBar = true;
      }, 50);
    } else if (addOrEdit == 'edit_contract') {
      let name: any;
      this.lmService.contract_show_div = addOrEdit;
      if (contact?.buyer) {
        name = contact?.buyer[0];
      }
      let exactName = name ? name : '';
      this.lmService.addTabInLevels('Contract' + ' - ' + exactName, contact?._id);
      this.lmService.contractId = contact?._id;
      this.lmService.propertyId = null;
      this.lmService.contact_showRightBar = true;
    } else if (addOrEdit == 'staff') {
      let name = contact?.contact?.full_name ? contact?.contact?.full_name : contact?.full_name ? contact?.full_name : '';
      this.lmService.addTabInLevels(`Staff-${name}`, contact?._id);
    }
  }
  public imagesLogo = null;
  onLogoSelect(event) {
    this.imagesLogo = [];
    if (this.imagesLogo == null) {
      this.imagesLogo = [];
    }
    if (event.target.files && event.target.files.length) {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        let logoName = event.target.files[i].name;

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);
        img.src = objectUrl;

        img.onload = () => {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(file);
          fileReader.onload = () => {
            this.property_img = null;
            this.imagesLogo.push({ name: logoName, file: fileReader.result });
          };
          URL.revokeObjectURL(objectUrl);
        };

        img.onerror = () => {
          this.toast.error('Corrupted image file! Please upload a valid image');
          this.property_img = null;
          URL.revokeObjectURL(objectUrl);
        };
      }
    }
  }
  new_or_editTask: boolean;
  selected_task: any;
  addNewTask(task, new_or_edit) {
    // Set the task mode (new or edit) and assign the selected task
    this.new_or_editTask = new_or_edit;
    this.selected_task = task;
    this.lmService.is_new_task = true;

    // If creating a new task, add it as a new tab in levels
    if (new_or_edit == true) {
      this.lmService.addTabInLevels('Task', this.property_id, null, { extra: 'properties' });
    }
    // If editing an existing task
    else if (new_or_edit == false) {
      // If mobile toggle is active, navigate to the tasks page with the task ID as a query param
      if (this.isMobileDevice == true) {
        this.router.navigate(['/tasks/all-tasks'], { queryParams: { id: task?._id } });
      }
      // Otherwise, add the task to levels with a formatted label
      else {
        this.lmService.addTabInLevels(`Task: REM-` + task?.id, task?._id, task);
      }
    }
  }

  taskRows: number = 15;
  taskScrollTop: number = 0;
  @ViewChild('taskScrollableElement') taskScrollableElement!: ElementRef;
  scrollTaskToTop(): void {
    const element = this.taskScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onTaskScroll(event: Event): void {
    const element = event.target;
    this.taskScrollTop = element['scrollTop'];
  }
  fullList: any;
  reminderList: any;
  getTasks() {
    // Check if the property ID is not 'createnew' before fetching tasks
    if (this.property_id !== 'createnew') {
      this._taskService.getTaskByPropertyId(this.property_id).subscribe({
        next: response => {
          this.isCache = true;

          // Process the received task list
          let fullListData = response.data?.map(el => {
            let today = moment();
            const dueDate = moment(el?.due_date);

            // Check if the due date is today or in the past
            const isFutureDate = dueDate?.isSame(today, 'day') || dueDate?.isBefore(today, 'day');

            // Mark tasks with high priority or past due dates with an exclamation flag
            if (el?.priority === 'High' || isFutureDate) {
              el = { ...el, is_exclamation: true };
            }
            return el;
          });

          // Filter out closed tasks
          fullListData = fullListData.filter(el => el.taskStatusName !== 'Closed');

          // Update the task list and count
          this.fullList = fullListData;
          this.taskRows = this.fullList?.length;

          // Sort tasks by due date if there are any tasks
          if (this.fullList.length > 0) {
            this.fullList.sort((a, b) => <any>new Date(a.due_date) - <any>new Date(b.due_date));
          }
          this.message.getModuleHistory(true);
        },
      });
    }
  }

  insertedPropertyId: any;
  sale_transaction: boolean = false;
  CreateProperty(onlyUpdateOrCreate) {
    if (this.property_id) {
      let isCache = this.localStorageService.GetItem('isPropCache');
      if (isCache !== null && isCache !== undefined) {
        let cache = Crypto.decrypt(isCache);
        cache.push(this.property_id);
        this.localStorageService.SetItem('isPropCache', Crypto.encrypt(cache));
        this.refreshProperty.emit(true);
      } else {
        let cache = [];
        cache.push(this.property_id);
        this.localStorageService.SetItem('isPropCache', Crypto.encrypt(cache));
        this.refreshProperty.emit(true);
      }
    }
    if (!this.insertedPropertyId) {
      this.submitDisable = true;
      this.submitted = true;
      this.editProperty.patchValue({
        office_id: this.api.getOfficeId(),
      });
      this.formHelper.validateAllFormFields(this.editProperty);
      if (!this.editProperty.valid) {
        let fields: any = Object.entries(this.editProperty.controls)
          .reduce((acc, [key, value]) => {
            if (value.status === 'INVALID') {
              acc.push(this.formalFields.find(errorfield => errorfield.name === key) || undefined);
            }
            return acc;
          }, [])
          ?.filter(error_field => error_field !== undefined && error_field !== null);
        fields ? this.validateFieldsOnRequest(fields) : this.formHelper.validateAllFormFields(this.editProperty);
        this.submitDisable = false;
        this.toast.error('Required fields must be filled in');
        return;
      } else if (!this.isAddressValid) {
        // Address typed but never resolved/selected from Google suggestions -> block creation
        this.submitDisable = false;
        this.submitted = false;
        this.toast.error('Property address not found on Google Api, Please contact Remmi support.');
        return;
      } else {
        let form_data = this.editProperty.value;
        form_data['properties_module'] = this.lmService.properties_module;
        form_data['car_space'] =
          this.editProperty.controls['garage'].value + this.editProperty.controls['car_port'].value + this.editProperty.controls['open_spaces'].value;
        form_data['properties_module'] = this.lmService.properties_module;
        if (this.imagesLogo?.length) {
          form_data['logos'] = [];
          form_data['logos'].push(this.imagesLogo[0]);
        }
        this._propertyService.createProperty(form_data).subscribe({
          next: response => {
            this._workflowService.isWorkflowProcessTabOpened == true && this.GetPropertyWorkflowProcesses();
            this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
            this.toast.success(response['message']);
            this.renderPropertyList.emit(true);
            this.propertyId.emit({ id: response?.insertedId });
            this.message.getModuleHistory(true);
            this.insertedPropertyId = response?.insertedId;
            this.isCache = false;
            this.property_id = this.insertedPropertyId;
            onlyUpdateOrCreate == 'onlyCreate' ? (this.sale_transaction = true) : false;
            if (onlyUpdateOrCreate !== 'onlyCreate') {
              let tab = this.lmService.tab_levels.find(el => el?._id == this?.insertedPropertyId || el?.name?.includes('Property'));
              if (tab) {
                let ind = this.lmService.tab_levels.indexOf(tab);
                this.editProperty.reset();
                this.property_close.emit({ level: tab, index: ind, id: this.insertedPropertyId });
              }
              this.previousOwner = null;
              this.listingPropertyHistory = null;
              this.allStatus = null;
              this.ownerId = null;
              this.getManualHistory = null;
              this.mergeHistoryArray = null;
            }
            this.submitDisable = false;
            this.disableAddListing = false;
            this.submitted = false;
            let id = this.api.getOfficeId();
            this.editProperty.patchValue({
              office_id: id,
            });
          },
          error: error => {
            this._workflowService.isWorkflowProcessTabOpened == true && this.GetPropertyWorkflowProcesses();
            let { fields, all_fields } = error?.error;
            if (fields?.length > 0) {
              this.formalFields = fields = fields
                ?.map(error_field => {
                  let isExistsField = all_fields?.find(field => field.name === error_field);
                  if (isExistsField) {
                    error_field = { name: error_field, label: isExistsField?.label || '' };
                  }
                  return error_field;
                })
                ?.filter(error_field => error_field !== undefined && error_field !== null);
              this.toast.error('Required fields must be filled in');
              this.validateFieldsOnRequest(fields);
            } else {
              this.toast.error(error.error['message']);
            }
            this.submitDisable = false;
            this.submitted = false;
          },
        });
      }
    } else {
      this.submitDisable = true;
      this.submitted = true;
      delete this.editProperty.value['office_id'];
      this.formHelper.validateAllFormFields(this.editProperty);
      if (!this.editProperty.valid) {
        let fields: any = Object.entries(this.editProperty.controls)
          .reduce((acc, [key, value]) => {
            if (value.status === 'INVALID') {
              acc.push(this.formalFields.find(errorfield => errorfield.name === key) || undefined);
            }
            return acc;
          }, [])
          ?.filter(error_field => error_field !== undefined && error_field !== null);
        fields && this.validateFieldsOnRequest(fields);
        this.submitDisable = false;
        this.toast.error('Required fields must be filled in');
        return;
      } else {
        let form_data = this.editProperty.value;
        form_data['car_space'] =
          this.editProperty.controls['garage'].value + this.editProperty.controls['car_port'].value + this.editProperty.controls['open_spaces'].value;
        if (this.imagesLogo?.length) {
          form_data['logos'] = [];
          form_data['logos'].push(this.imagesLogo[0]);
        }
        this._propertyService.updatePropertyById(this.insertedPropertyId, form_data).subscribe({
          next: response => {
            this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
            this.toast.success(response['message']);
            this.isCache = false;
            this.message.getModuleHistory(true);
            this.renderPropertyList.emit(true);
            let id = this.api.getOfficeId();
            this.editProperty.patchValue({
              office_id: id,
            });
            // onlyUpdateOrCreate == 'onlyCreate' ? this.sale_transaction = true : false;
            this.lmService.tab_levels = this.lmService.tab_levels.map(tab => {
              if (tab._id === this.insertedPropertyId) {
                tab.data.property_address = this.editProperty.controls['property_address'].value;
                tab.name = `Property - ${this.editProperty.controls['property_address'].value}`;
              }
              return tab;
            });
            if (onlyUpdateOrCreate !== 'onlyCreate') {
              let tab = this.lmService.tab_levels.find(el => el._id == this.insertedPropertyId || el?.name?.includes('Property'));
              if (tab) {
                let ind = this.lmService.tab_levels.indexOf(tab);
                this.editProperty.reset();
                this.property_close.emit({ level: tab, index: ind, id: this.insertedPropertyId });
              }
              this.previousOwner = null;
              this.listingPropertyHistory = null;
              this.allStatus = null;
              this.ownerId = null;
              this.getManualHistory = null;
              this.mergeHistoryArray = null;
            }
            this.submitDisable = false;
            this.submitted = false;
          },
          error: error => {
            let { fields, all_fields } = error?.error;
            if (fields?.length > 0) {
              this.formalFields = fields = fields
                ?.map(error_field => {
                  let isExistsField = all_fields?.find(field => field.name === error_field);
                  if (isExistsField) {
                    error_field = { name: error_field, label: isExistsField?.label || '' };
                  }
                  return error_field;
                })
                ?.filter(error_field => error_field !== undefined && error_field !== null);
              this.toast.error('Required fields must be filled in');
              this.validateFieldsOnRequest(fields);
            } else {
              this.toast.error(error.error['message']);
            }
            this.submitDisable = false;
            this.submitDisable = false;
            this.submitted = false;
          },
        });
      }
    }
  }

  shouldResetDocuments: boolean = false;
  resetDocuments() {
    setTimeout(() => (this.shouldResetDocuments = false), 500);
  }
  updateProperty(onlyUpdateOrCreate) {
    if (this.property_id) {
      let isCache = this.localStorageService.GetItem('isPropCache');
      if (isCache !== null && isCache !== undefined) {
        let cache = Crypto.decrypt(isCache);
        cache.push(this.property_id);
        this.localStorageService.SetItem('isPropCache', Crypto.encrypt(cache));
        this.refreshProperty.emit(true);
      } else {
        let cache = [];
        cache.push(this.property_id);
        this.localStorageService.SetItem('isPropCache', Crypto.encrypt(cache));
        this.refreshProperty.emit(true);
      }
    }

    this.submitDisable = true;
    this.submitted = true;
    delete this.editProperty.value['office_id'];
    this.formHelper.validateAllFormFields(this.editProperty);
    if (!this.editProperty.valid) {
      let fields: any = Object.entries(this.editProperty.controls)
        .reduce((acc, [key, value]) => {
          if (value.status === 'INVALID') {
            acc.push(this.formalFields.find(errorfield => errorfield.name === key) || undefined);
          }
          return acc;
        }, [])
        ?.filter(error_field => error_field !== undefined && error_field !== null);
      fields && this.validateFieldsOnRequest(fields);
      this.submitDisable = false;
      this.toast.error('Required fields must be filled in');
      return;
    } else {
      let form_data = this.editProperty.value;
      form_data['car_space'] =
        this.editProperty.controls['garage'].value + this.editProperty.controls['car_port'].value + this.editProperty.controls['open_spaces'].value;
      if (this.imagesLogo?.length) {
        form_data['logos'] = [];
        form_data['logos'].push(this.imagesLogo[0]);
      }
      this._propertyService.updatePropertyById(this.selectedProperty._id, form_data).subscribe({
        next: response => {
          this._workflowService.isWorkflowProcessTabOpened == true && this.GetPropertyWorkflowProcesses();
          this.numOfNotValidFields = this.requiredErrorMessages.length = 0;
          this.toast.success(response['message']);
          this.isCache = false;
          this.message.getModuleHistory(true);
          this.renderPropertyList.emit(true);
          let id = this.api.getOfficeId();
          this.editProperty.patchValue({
            office_id: id,
          });
          this.lmService.tab_levels = this.lmService.tab_levels.map(tab => {
            if (tab._id === this.selectedProperty._id) {
              tab.data.property_address = this.editProperty.controls['property_address'].value;
              tab.name = `Property - ${this.editProperty.controls['property_address'].value}`;
            }
            return tab;
          });
          if (onlyUpdateOrCreate !== 'onlyUpdate') {
            let tab = this.lmService.tab_levels.find(el => el?._id == this.selectedProperty?._id);
            if (tab) {
              let ind = this.lmService.tab_levels.indexOf(tab);
              this.editProperty.reset();
              this.property_close.emit({ level: tab, index: ind, id: this.insertedPropertyId });
            }
            this.previousOwner = null;
            this.listingPropertyHistory = null;
            this.allStatus = null;
            this.ownerId = null;
            this.getManualHistory = null;
            this.mergeHistoryArray = null;
            this.route.queryParams.subscribe(params => {
              if (params['id']) {
                this.router.navigate(['.'], { relativeTo: this.route });
              }
            });
          }
          this.submitDisable = false;
          this.submitted = false;
        },
        error: error => {
          this._workflowService.isWorkflowProcessTabOpened == true && this.GetPropertyWorkflowProcesses();
          let { fields, all_fields } = error?.error;
          if (fields?.length > 0) {
            this.formalFields = fields = fields
              ?.map(error_field => {
                let isExistsField = all_fields?.find(field => field.name === error_field);
                if (isExistsField) {
                  error_field = { name: error_field, label: isExistsField?.label || '' };
                }
                return error_field;
              })
              ?.filter(error_field => error_field !== undefined && error_field !== null);
            this.toast.error('Required fields must be filled in');
            this.validateFieldsOnRequest(fields);
          } else {
            this.toast.error(error.error['message']);
          }
          this.submitDisable = false;
          this.submitDisable = false;
          this.submitted = false;
        },
      });
    }
  }

  isLatestListing: boolean = false;
  isLatestManual: boolean = false;
  listingPropertyHistory: any[] = [];
  getManualHistory: any[] = [];
  allStatus: any[] = [];
  contactLists: any[] = [];
  ownerId: any[] = [];
  mergeHistoryArray: any[] = [];

  allowChangeDate() {
    if (this.user_role == 'master admin' || this.user_role == 'operations manager') {
      this.is_date_show = true;
    }
  }

  public change_date = null;
  is_date_show: boolean = false;
  changeDate(id) {
    // Send a request to update the listing date
    this.api
      .put('/listing/update-created-date/' + id, {
        created_at: new Date(Utils.getDateStringFormat(this.change_date)), // Format and update the date
      })
      .subscribe({
        next: _ => {
          // Show success notification
          this.toast.success('Date updated successfully');

          // Refresh the listing history
          this.listingHistory();

          // Hide the date picker/input field
          this.is_date_show = false;
        },
      });
  }

  getPreviousOwners(listingStatus: any[]) {
    return listingStatus?.filter(con => con.type?.includes('Seller') || con.type?.includes('Owner'));
  }

  listingHistory() {
    let latestRecord = [];
    this.previousOwner = [];
    this.listingPropertyHistory = [];
    this.allStatus = [];
    this.ownerId = [];
    this.getManualHistory = [];
    this.mergeHistoryArray = [];
    this._historyService.getPropertyTransactionHistory(this.property_id).subscribe({
      next: response => {
        this.listingPropertyHistory = response?.data;
        // Not show Owner this part
        this.listingPropertyHistory.forEach(x => {
          if (x?.is_latest === true) {
            this.contactLists = x?.listing_contacts?.filter(
              y =>
                y?.is_settlement === true ||
                (y?.type?.toString()?.toLowerCase()?.includes('buyer') && !y?.type?.toString()?.toLowerCase()?.includes('buyer solicitor'))
            );
            if (this.contactLists.length > 0) {
              this.contactLists?.forEach(x => {
                this.ownerId.push(x?.contacts?._id);
              });
              this.manualHistory.seller = this.ownerId;
            } else {
              let sellerOwner = x?.listing_contacts?.filter(
                y => y?.type?.toString()?.toLowerCase()?.includes('seller') || y?.type?.toString()?.toLowerCase()?.includes('owner')
              );
              sellerOwner?.forEach(x => {
                this.ownerId.push(x?.contacts?._id);
              });
              this.manualHistory.seller = this.ownerId;
            }
          }
        });
        // End
        latestRecord = response?.data?.filter(x => x?.is_latest === true);
        this.allStatus = response?.data;
        this.allStatus.forEach(x => {
          const matchingStatus = this.listingService.listingPropertyOption.property_Status.find(y => y?.tag_name === x?.property_status);
          if (matchingStatus) {
            x['text_color'] = matchingStatus?.text_color;
            x['background_color'] = matchingStatus?.background_color;
          }
          if (
            x?.is_latest == true &&
            x?.property_status.toLocaleLowerCase() != 'sold' &&
            x?.property_status.toLocaleLowerCase() != 'withdrawn' &&
            x?.property_status.toLocaleLowerCase() != 'withdraw' &&
            x?.property_status.toLocaleLowerCase() != 'leased'
          ) {
            x['is_hide'] = true;
          }
        });
        if (latestRecord.length <= 0) {
          this._historyService.getManualHistoryByPropertyId(this.property_id).subscribe({
            next: response => {
              response?.data.forEach(x => {
                const matchingStatus = this.listingService.listingPropertyOption.property_Status.find(y => y?.tag_name === x?.property_status);
                if (matchingStatus) {
                  x['text_color'] = matchingStatus?.text_color;
                  x['background_color'] = matchingStatus?.background_color;
                }
              });
              this.getManualHistory = response?.data.filter(x => x?.is_show_in_history !== false);
              this.mergeHistoryArray = this.getManualHistory;
              this.allStatus.forEach(x => {
                this.mergeHistoryArray.push(x);
              });
              this.mergeHistoryArray = this.mergeHistoryArray.sort((a, b) => new Date(b?.created_at).getTime() - new Date(a?.created_at).getTime());
              if (this.mergeHistoryArray.length > 1) {
                if (this.mergeHistoryArray[1].hasOwnProperty('listing_contacts')) {
                  let filterDataSeller = this.mergeHistoryArray[1].listing_contacts.filter(
                    e => e?.type?.toString()?.toLowerCase()?.includes('seller') && !e?.type?.toString()?.toLowerCase()?.includes('seller solicitor')
                  );
                  if (filterDataSeller.length > 0) {
                    this.previousOwner = filterDataSeller;
                  }
                } else {
                  if (this.mergeHistoryArray[1].buyer && this.mergeHistoryArray[1]?.buyer?.length > 0) {
                    this.previousOwner = this.mergeHistoryArray[1].buyer;
                  } else {
                    this.previousOwner = this.mergeHistoryArray[1].seller;
                  }
                }
              }
              latestRecord = response?.data?.filter(x => x?.is_latest === true);
              response?.data?.forEach(x => {
                if (x?.is_latest === true) {
                  if (!x?.buyer?.length) {
                    this.ownerId = [];
                    x.seller?.forEach(x => {
                      this.ownerId.push(x?._id);
                    });
                  } else {
                    this.ownerId = [];
                    x?.buyer?.forEach(x => {
                      this.ownerId.push(x?._id);
                    });
                  }
                }
              });
              if (latestRecord.length > 0) {
                this.isLatestManual = true;
                this.isLatestListing = false;
              }
            },
          });
        } else {
          this.isLatestListing = true;
          this.isLatestManual = false;
          this._historyService.getManualHistoryByPropertyId(this.property_id).subscribe({
            next: response => {
              response?.data.forEach(x => {
                const matchingStatus = this.listingService.listingPropertyOption.property_Status.find(y => y?.tag_name === x?.property_status);
                if (matchingStatus) {
                  x['text_color'] = matchingStatus?.text_color;
                  x['background_color'] = matchingStatus?.background_color;
                }
              });
              let arrayOfData = response?.data.filter(x => x?.is_show_in_history !== false);
              this.mergeHistoryArray = this.allStatus;
              arrayOfData.forEach(x => {
                this.mergeHistoryArray.push(x);
              });
              console.log('mergeHistoryArray:', this.mergeHistoryArray);
              this.mergeHistoryArray = this.mergeHistoryArray.sort((a, b) => new Date(b?.created_at).getTime() - new Date(a?.created_at).getTime());
              if (this.mergeHistoryArray.length > 0) {
                if (this.mergeHistoryArray[1].hasOwnProperty('listing_contacts')) {
                  let filterDataSeller = this.mergeHistoryArray[1].listing_contacts.filter(
                    e => e?.type?.toString()?.toLowerCase()?.includes('seller') && !e?.type?.toString()?.toLowerCase()?.includes('seller solicitor')
                  );
                  if (filterDataSeller.length > 0) {
                    this.previousOwner = filterDataSeller?.map(el => el?.contacts);
                  }
                } else {
                  if (this.mergeHistoryArray[1].seller && this.mergeHistoryArray[1].seller.length > 0) {
                    this.previousOwner = this.mergeHistoryArray[1].seller;
                  }
                }
              }
            },
          });
        }
      },
    });
  }

  buyerName(buyer) {
    return buyer?.map(b => b.full_name).join(' ') || '';
  }

  propertyList: any[] = [];
  disablePropertyAddress = false;
  getProperty() {
    // Fetch property list for the current office
    let payload = {
      page: 1,
      per_page: 99999,
      gridview: true,
    };
    this._propertyService.getPropertiesList(payload).subscribe({
      next: response => {
        // Store the retrieved property list
        this.propertyList = response?.data;

        // Refresh properties in the service
        this.lmService.getProperties(false);
        // Check if the entered property address already exists
        this.lmService.properties.forEach(x => {
          if (x?.property_address == this.editProperty.controls['property_address'].value && this.user_role == 'sales agent') {
            // Disable the property address field if it already exists
            this.disablePropertyAddress = true;
          }
        });
      },
    });
  }

  isSearchTrue = false;
  isAvailableTrue = true;
  isAddressValid = true; // false while a fresh Google address is being typed and not yet selected from suggestions
  filterProperty: any[] = [];
  previousPropertyDetail = null;
  @ViewChild('addressInput') addressInput!: ElementRef;
  @ViewChild('propertyInput') propertyInput!: ElementRef;
  filterPropertyListing(param) {
    // Get the property address value from the form
    let val = this.editProperty.controls['property_address'].value;

    if (param == 'google') {
      // Typing a fresh Google address -> invalid until a suggestion is selected
      this.isAddressValid = false;
      // If no value is entered, set availability flag to true
      this.isAvailableTrue = !val ? true : false;

      // Focus on the property input field
      setTimeout(() => {
        if (this.propertyInput) {
          this.propertyInput.nativeElement.focus();
        }
      }, 0);
    } else {
      this.isSearchTrue = true; // Activate search mode

      // Filter the property list based on the entered address
      this.filterProperty = this.propertyList?.filter(ele => ele?.property_address?.toLowerCase()?.includes(val?.toLowerCase()));

      if (this.filterProperty?.length > 0) {
        // Show available results if matches are found
        this.isAvailableTrue = true;
        this.isSearchTrue = true;
      } else {
        // Hide results if no matches are found
        this.isAvailableTrue = false;
        this.isSearchTrue = false;

        // Focus on the address input field
        setTimeout(() => {
          if (this.addressInput) {
            this.addressInput.nativeElement.focus();
          }
        }, 0);
      }
    }
  }

  selectFilterItem(item) {
    // Reset search state
    this.isSearchTrue = false;

    // Clear tab levels
    this.lmService.tab_levels = [];

    // Set property display mode to 'edit'
    this.lmService.property_show_div = 'edit_property';

    // Add the selected property to the tab levels
    this.lmService.addTabInLevels('Property' + ' - ' + item?.property_address, item?._id, item);

    // Retrieve router history from local storage
    let history_item = Crypto.decrypt(this.localStorageService.GetItem('router-history'));

    // Check if the property already exists in history, if not, add it
    if (!history_item?.find(ele => ele.name == item?.property_address)) {
      history_item.push({
        id: Utils.generateUUID(), // Generate a unique ID
        name: item?.property_address,
        pin_id: null,
        data: null,
        extra: {},
        _id: item?._id,
        link: `/property/properties`,
        param: null,
        title: 'Properties',
      });

      // Save updated history back to local storage
      this.localStorageService.SetItem('router-history', Crypto.encrypt(history_item));
    }

    // Show the right sidebar
    this.lmService.showRightBar = true;
  }

  emptySearch() {
    this.isSearchTrue = false;
    this.isAddressValid = true;
    this.filterProperty = [];
    this.previousPropertyDetail = null;
    this.editProperty.reset();
  }

  handleAddressChange(address: any) {
    console.log('Addresses', address);
    // Address not resolved by Google API (no components/geometry) -> keep flagged invalid, no toast on select
    if (!address?.address_components?.length || !address?.geometry?.location) {
      this.isAddressValid = false;
      return;
    }
    // Valid Google selection
    this.isAddressValid = true;
    this.editProperty.patchValue({
      building_name: null,
      unit_no: null,
      street_no: null,
      street_name: null,
      suburb: null,
      state: null,
      post_code: null,
      country: null,
      latitude: address.geometry.location.lat(),
      longitude: address.geometry.location.lng(),
    });
    address?.address_components.forEach(el => {
      el.types.forEach(type => {
        if (type === 'premise') {
          this.editProperty.patchValue({
            building_name: `"${el?.long_name.replace(/"/g, '')}"`,
          });
        } else if (type === 'subpremise') {
          this.editProperty.patchValue({
            unit_no: el?.long_name,
          });
        } else if (type === 'street_number') {
          this.editProperty.patchValue({
            street_no: el?.long_name,
          });
        } else if (type === 'route') {
          // street name
          this.editProperty.patchValue({
            street_name: el?.long_name,
          });
        } else if (type === 'locality') {
          // Suburb
          let suburb = this.filteredItems.find(sub => sub.suburb === el?.long_name);
          if (suburb) {
            suburb['lat'] = address.geometry.location.lat();
            suburb['lng'] = address.geometry.location.lng();
            suburb['suburb'] = el?.long_name;
            this.editProperty.patchValue({
              suburb: suburb,
            });
          } else {
            let suburb = {
              lat: address.geometry.location.lat(),
              lng: address.geometry.location.lng(),
              suburb: el?.long_name,
            };
            this.editProperty.patchValue({
              suburb: suburb,
            });
          }
        } else if (type === 'administrative_area_level_1') {
          // State
          this.editProperty.patchValue({
            state: el?.short_name,
          });
        } else if (type === 'postal_code') {
          this.editProperty.patchValue({
            post_code: el?.short_name,
          });
        } else if (type === 'country') {
          this.editProperty.patchValue({
            country: el?.long_name,
          });
        }
      });
    });
    let new_address = `${this.editProperty.get('building_name').value ? `"${this.editProperty.get('building_name').value}"` : ''} ${
      this.editProperty.get('unit_no').value ? this.editProperty.get('unit_no').value : ''
    } ${
      this.editProperty.get('street_no').value
        ? this.editProperty.get('street_no').value //+ ""
        : ''
    } ${
      this.editProperty.get('street_name').value
        ? this.editProperty.get('street_name').value //+ ","
        : ''
    } ${this.editProperty.get('suburb').value?.suburb ? this.editProperty.get('suburb').value?.suburb + ',' : ''} ${
      this.editProperty.get('state').value
        ? this.editProperty.get('state').value //+ ","
        : ''
    } ${this.editProperty.get('post_code').value ? this.editProperty.get('post_code').value : ''}`;
    if (
      this.editProperty?.get('unit_no')?.value?.trim() !== undefined &&
      this.editProperty?.get('unit_no')?.value?.trim() !== null &&
      this.editProperty?.get('unit_no')?.value?.trim() !== '' &&
      this.editProperty?.get('street_no')?.value?.trim() !== undefined &&
      this.editProperty?.get('street_no')?.value?.trim() !== null &&
      this.editProperty?.get('street_no')?.value?.trim() !== ''
    ) {
      new_address =
        new_address.substring(0, new_address.indexOf(this.editProperty?.get('street_no')?.value?.trim()) - 1) +
        new_address.substring(new_address.indexOf(this.editProperty?.get('street_no')?.value?.trim()), new_address?.length);
      new_address = [
        new_address.slice(0, new_address.indexOf(this.editProperty?.get('street_no')?.value?.trim())),
        '/',
        new_address.slice(new_address.indexOf(this.editProperty?.get('street_no')?.value?.trim())),
      ].join('');
    }
    let modifyAddress = new_address.trim();
    if (!modifyAddress) {
      this.toast.error('Invalid Address');
      this.editProperty.controls['property_address'].reset();
    } else {
      this.editProperty.patchValue({
        property_address: modifyAddress, //.replace("Australia", ""),
      });
    }
  }

  updateAddress() {
    // Same shape a Google selection produces: "<building>" <unit>/<street no> <street name> <suburb>, <state> <post code>
    const buildingName = `${this.editProperty.get('building_name').value ?? ''}`.trim().replace(/"/g, '');
    const unitNo = `${this.editProperty.get('unit_no').value ?? ''}`.trim();
    const streetNo = `${this.editProperty.get('street_no').value ?? ''}`.trim();
    const streetName = `${this.editProperty.get('street_name').value ?? ''}`.trim();
    const suburbValue = this.editProperty.get('suburb').value;
    const suburb = `${(typeof suburbValue === 'string' ? suburbValue : suburbValue?.suburb) ?? ''}`.trim();
    const state = `${this.editProperty.get('state').value ?? ''}`.trim();
    const postCode = `${this.editProperty.get('post_code').value ?? ''}`.trim();

    // Unit and street number are joined with '/', never concatenated (125 + 43 -> 125/43)
    const streetNumber = unitNo && streetNo ? `${unitNo}/${streetNo}` : unitNo || streetNo;

    const address = [buildingName ? `"${buildingName}"` : '', streetNumber, streetName, suburb ? `${suburb},` : '', state, postCode]
      .filter(part => part)
      .join(' ');

    this.syncSuburbCoordinates();

    // Update the form field with the formatted address
    this.editProperty.patchValue({
      property_address: address,
    });
  }

  /**
   * Mirrors the manually entered latitude/longitude onto the suburb object, which is where
   * the rest of the app (map markers) reads a property's coordinates from.
   */
  syncSuburbCoordinates() {
    const latitude = this.editProperty.get('latitude').value;
    const longitude = this.editProperty.get('longitude').value;
    if ((latitude === null || latitude === '') && (longitude === null || longitude === '')) {
      return;
    }

    const suburbValue = this.editProperty.get('suburb').value;
    const suburb = typeof suburbValue === 'string' ? { suburb: suburbValue } : { ...suburbValue };
    if (latitude !== null && latitude !== '') {
      suburb['lat'] = Number(latitude);
    }
    if (longitude !== null && longitude !== '') {
      suburb['lng'] = Number(longitude);
    }

    this.editProperty.patchValue({
      suburb: suburb,
    });
  }

  GetLibraryData(eve) {
    console.log('Eve', eve);
    this.message.getModuleHistory(true);
  }

  clear(item, nameType) {
    if (nameType == 'owner') {
      this.manualHistory.seller = this.manualHistory.seller.filter(x => x !== item);
    }
    if (nameType == 'b_owner') {
      this.manualHistory.buyer = this.manualHistory.buyer.filter(x => x !== item);
    } else if (nameType == 'ap_owner') {
      this.appraisal.owner = this.appraisal.owner.filter(x => x !== item);
    } else if (nameType == 'agent') {
      this.appraisal.agent = this.appraisal.agent.filter(x => x !== item);
    }
  }
  createManualTransaction() {
    this.manualGenerateHistory = true;
    this.isEdit = false;
    this.isManual = false;
    this.manualHistory.seller = this.ownerId;
  }
  errorMessage: boolean = false;
  is_disable_history: boolean = false;
  saveHistory() {
    // Get the property ID (either existing or newly inserted)
    let id = this.property_id ? this.property_id : this.insertedPropertyId;

    if (id) {
      // Ensure required fields are provided before proceeding
      if (this.manualHistory.price && this.manualHistory.buyer.length > 0 && this.manualHistory.date) {
        this.is_disable_history = true; // Disable button to prevent duplicate submissions

        // Assign property ID to history
        this.manualHistory['property_id'] = id;
        let formData = this.manualHistory;
        formData['associate_date'] = new Date(); // Set the current date

        // API call to create manual history entry
        this._propertyService.savePropertyHistory(formData).subscribe(res => {
          this.toast.success(res?.message); // Show success message
          this.is_disable_history = false; // Re-enable button

          // Refresh data
          this.listingHistory();
          this.message.getModuleHistory(true);
          // Reset form fields
          this.errorMessage = false;
          this.manualGenerateHistory = false;
          this.manualHistory.agent = null;
          this.manualHistory.property_status = null;
          this.manualHistory.buyer = [];
          this.manualHistory.date = null;
          this.manualHistory.price = null;
        });
      } else {
        this.errorMessage = true; // Show error if required fields are missing
        this.is_disable_history = false;
      }
    } else {
      this.toast.error('First create the property'); // Show error if property is not created
    }
  }
  cancelTransaction() {
    this.manualGenerateHistory = false;
    this.isManual = false;
    this.contactBuyer = null;
    this.contactSeller = null;
    this.manualHistory.agent = null;
    this.manualHistory.seller = [];
    this.manualHistory.property_status = null;
    this.manualHistory.buyer = [];
    this.manualHistory.date = null;
    this.manualHistory.price = null;
  }
  isManual = false;
  contactBuyer = null;
  showBuyer = false;
  showSeller = false;
  contactSeller = null;

  updateContactHistory(event) {
    // Reset buyer and seller contact selections
    this.contactBuyer = null;
    this.contactSeller = null;

    // Enable edit and manual mode
    this.isEdit = true;
    this.isManual = true;

    // Check event type and assign contact accordingly
    if (event['type'].includes('Seller') || event['type'].includes('Owner')) {
      this.contactSeller = event?.contacts?._id;
      this.showBuyer = false;
      this.showSeller = true;
    } else if (event['type'].includes('Buyer')) {
      this.showBuyer = true;
      this.showSeller = false;
      this.contactBuyer = event?.contacts?._id;
    }

    // Store event ID for further processing
    this.eventId = event?._id;
  }
  saveContactHistory() {
    // Check if either a buyer or seller contact exists
    if (this.contactBuyer || this.contactSeller) {
      // Set the contact ID based on available contact (buyer or seller)
      let contact_id = { contact_id: this.contactBuyer || this.contactSeller };

      // API call to update property contact details
      this._propertyService.saveContactHistory(this.eventId, contact_id).subscribe({
        next: response => {
          this.listingHistory(); // Refresh listing history
          this.message.getModuleHistory(true);
          this.toast.success(response?.message); // Show success message
          // Reset form and flags
          this.errorMessage = false;
          this.isEdit = false;
          this.isManual = false;
        },
      });
    } else {
      this.errorMessage = true; // Show error if no contact is selected
    }
  }
  isEdit: boolean = false;
  eventId: any;
  updateHistory(event) {
    this.isEdit = true;
    this.manualGenerateHistory = true;
    let owner = [];
    let p_owner = [];
    this.manualHistory.property_status = event?.property_status;
    this.manualHistory.agent = event?.agent;
    this.manualHistory.date = event?.date ? new Date(event?.date) : null;
    event?.seller?.forEach(x => {
      owner.push(x?._id);
    });
    event?.buyer?.forEach(x => {
      p_owner.push(x?._id);
    });
    this.manualHistory.seller = owner;
    this.manualHistory.buyer = p_owner || [event?.contact_id];
    this.manualHistory.price = event?.price;
    this.eventId = event?._id;
  }

  updatePrice(value) {
    console.log('value >>:', value);
    this.manualHistory.price = value;
  }

  selectDate() {
    let date_value = this.manualHistory.date;
    let val = Utils.getDateStringFormat(date_value);
    this.manualHistory.date = new Date(val);
  }

  updateSaveHistory() {
    // Validate required fields before proceeding
    if (this.manualHistory.price && this.manualHistory.buyer.length > 0 && this.manualHistory.date) {
      this.is_disable_history = true; // Disable button to prevent duplicate submissions

      // Assign property ID
      this.manualHistory['property_id'] = this.property_id ? this.property_id : this.insertedPropertyId;

      let formData = this.manualHistory;

      // API call to update property manual history
      this._propertyService.updateManualHistory(this.eventId, formData).subscribe(res => {
        this.is_disable_history = false; // Re-enable button after response
        this.listingHistory(); // Refresh listing
        this.message.getModuleHistory(true);
        this.toast.success(res?.message); // Show success message

        // Reset form and flags
        this.errorMessage = false;
        this.manualGenerateHistory = false;
        this.isEdit = false;
        this.manualHistory.agent = null;
        this.manualHistory.seller = [];
        this.manualHistory.property_status = null;
        this.manualHistory.buyer = [];
        this.manualHistory.date = null;
        this.manualHistory.price = null;
      });
    } else {
      this.errorMessage = true; // Show error if validation fails
      this.is_disable_history = false;
    }
  }
  transformPrice() {
    let comma = this.manualHistory.price.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    this.manualHistory.price = comma;
  }

  createAppraisal: boolean = false;
  cancelAppraisal(form) {
    this.createAppraisal = false;
    form.reset();
  }
  showAppraisal() {
    this.createAppraisal = true;
    this.insertedAppraisalId = null;
    this.isUpdate = false;
    this.appraisalFormReset();
    let sale_agent = [];
    // if (this.user_role === 'sales agent') {
    sale_agent.push(this.AuthUser?._id);
    // }
    this.appraisal.agent = sale_agent;
    this.appraisal.owner = this.ownerId;
  }

  onDateSelect(event) {
    let val = new Date(Utils.getDateStringFormat(event));
    this.appraisal.appraisal_Date = new Date(val);
    console.log('appraisal.appraisal_Date', this.appraisal.appraisal_Date);
  }
  insertedAppraisalId: any;
  saveAppraisal(method) {
    // Check if an appraisal already exists
    if (!this.insertedAppraisalId) {
      // Ensure a property exists before creating an appraisal
      if (this.property_id || this.insertedPropertyId) {
        this.appraisal['property_id'] = this.property_id ? this.property_id : this.insertedPropertyId;
        this.appraisal['office_id'] = this.api.getOfficeId();
        this.appraisal['user_id'] = this.api.getUserId();

        let formData = this.appraisal;

        // API call to create a new appraisal
        this._propertyService.createPropertyAppraisal(formData).subscribe(res => {
          this.insertedAppraisalId = res?.insertedId; // Store inserted appraisal ID
          this.toast.success(res?.message);
          this.getAppraisal(); // Refresh appraisal data
          this.message.getModuleHistory(true);
        });

        // Close the form if the method is not 'onlySave'
        if (method !== 'onlySave') {
          this.createAppraisal = false;
          this.appraisalFormReset();
        }
      } else {
        this.toast.error('Please first create property'); // Show error if no property exists
      }
    } else {
      // Update existing appraisal if it already exists
      this.appraisal['property_id'] = this.property_id ? this.property_id : this.insertedPropertyId;
      this.appraisal['office_id'] = this.api.getOfficeId();

      let formData = this.appraisal;

      // API call to update appraisal
      this._propertyService.updatePropertyAppraisal(this.insertedAppraisalId, formData).subscribe(res => {
        this.toast.success(res?.message);
        this.getAppraisal(); // Refresh appraisal data
        this.message.getModuleHistory(true);
      });

      // Close the form if the method is not 'onlySave'
      if (method !== 'onlySave') {
        this.createAppraisal = false;
        this.appraisalFormReset();
      }
    }
  }
  disableAppraisalRows(item) {
    if (
      !this.user_permission.includes('appraisal.manage') ||
      (!this.user_permission.includes('appraisal.edit') && this.user_role !== 'master admin' && this.user_role !== 'operations manager')
    ) {
      if (!this.user_permission.includes('appraisal.manage') && this.user_permission.includes('appraisal.edit') && this.user_role != 'master admin') {
        if (item.user_id != this.api.getUserId()) {
          return true;
        }
      }
      return false;
    } else {
      return true;
    }
  }
  isUpdate: boolean = false;
  updateApp(item) {
    /**
     * Updates an appraisal of a property.
     * If the user has permission to update the appraisal, this method will open the appraisal form and populate it with the selected appraisal's data.
     * @param item The appraisal object to be updated.
     */
    if (this.user_permission.includes('appraisal.manage') || this.user_permission.includes('appraisal.edit') || this.user_role == 'master admin') {
      /**
       * Check if the user has permission to edit the appraisal.
       * If the user does not have permission to edit the appraisal, show an error message and return without doing anything.
       */
      if (!this.user_permission.includes('appraisal.manage') && this.user_permission.includes('appraisal.edit') && this.user_role != 'master admin') {
        if (item.user_id != this.api.getUserId()) {
          this.toast.error('Access denied');
          return 0;
        }
      }
      /**
       * Open the appraisal form.
       */
      this.createAppraisal = true;
      /**
       * Set the appraisal object to be updated.
       */
      this.isUpdate = true;
      /**
       * Populate the appraisal form with the selected appraisal's data.
       */
      this.appraisal.appraisal_Date = item?.appraisal_Date ? new Date(item?.appraisal_Date) : null;
      this.appraisal.price_guide = item?.price_guide;
      let agent = [];
      item?.agent.forEach(x => agent.push(x?._id));
      this.appraisal.agent = agent;
      this.appraisal.appraisal_status = item?.appraisal_status;
      let owner = [];
      item?.owner.forEach(x => owner.push(x?._id));
      this.appraisal.owner = owner;
      this.appraisal.lead_source = item?.lead_source;
      this.appraisal.notes = item?.notes;
      /**
       * Set the appraisal ID of the appraisal to be updated.
       */
      this.insertedAppraisalId = item?._id;
    } else {
      /**
       * If the user does not have permission to update the appraisal, show an error message.
       */
      this.toast.error('Access denied');
    }
  }
  updateAppraisal(method) {
    /**
     * Updates an appraisal of a property.
     * Sends a PUT request to the server with the updated appraisal data.
     * If successful, shows a success toast message and refreshes the appraisal list.
     * @param form The form containing the updated appraisal data.
     * @param method The method to use when saving the appraisal. If "onlySave", the form is not reset after saving.
     */
    this.appraisal['property_id'] = this.property_id ? this.property_id : this.insertedPropertyId;
    this.appraisal['office_id'] = this.api.getOfficeId();
    let formData = this.appraisal;
    this._propertyService.updatePropertyAppraisal(this.insertedAppraisalId, formData).subscribe(res => {
      this.isUpdate = false;
      this.toast.success(res?.message);
      this.getAppraisal(); // Refresh the appraisal list
      this.message.getModuleHistory(true);
    });
    if (method !== 'onlySave') {
      this.createAppraisal = false;
      this.appraisalFormReset(); // Reset the form
    }
  }
  deleteAppraisal(id, _event) {
    /**
     * Opens a confirmation dialog box to confirm whether the user wants to delete the appraisal from the property.
     * If confirmed, sends a DELETE request to the server to delete the appraisal.
     * If successful, shows a success toast message and refreshes the appraisal list.
     * @param id The id of the appraisal to be deleted.
     * @param event The event that triggered the delete action.
     */
    this.remmiConfirm
      .delete({
        title: 'Remove Appraisal?',
        message: 'This appraisal will be permanently removed from this property.',
        confirmLabel: 'Remove',
      })
      .subscribe(isConfirmed => {
        if (!isConfirmed) return;
        this._propertyService.deletePropertyAppraisal(id).subscribe(res => {
          this.toast.success(res?.message);
          this.getAppraisal(); // Refresh the appraisal list
        });
      });
  }
  appraisalRows: number = 15;
  appraisalScrollTop: number = 0;
  @ViewChild('appraisalScrollableElement') appraisalScrollableElement!: ElementRef;
  scrollAppraisalToTop(): void {
    const element = this.appraisalScrollableElement.nativeElement as HTMLElement;
    element.scrollTop = 0;
  }
  onAppraisalScroll(event: Event): void {
    const element = event.target;
    this.appraisalScrollTop = element['scrollTop'];
  }
  appraisalList: any[] = [];
  getAppraisal() {
    /**
     * Get the appraisal list for the selected property
     * @returns The appraisal list
     */
    if (this.property_id !== 'createnew') {
      this._propertyService.getPropertyAppraisal(this.property_id).subscribe(res => {
        this.appraisalList = [];
        // If the user has permission to manage or view appraisals, get the full list
        if (
          this.user_permission.includes('appraisal.manage') ||
          this.user_permission.includes('appraisal.view') ||
          this.user_role == 'master admin'
        ) {
          this.appraisalList = res.data.map(x => {
            return { ...x, isOpen: true };
          });
        } else {
          // If the user does not have permission, get the list of appraisals that they created
          this.appraisalList = res.data
            .map(x => {
              return { ...x, isOpen: true };
            })
            .filter(e => e.user_id == this.api.getUserId());
        }
        // Set the number of appraisal rows
        this.appraisalRows = this.appraisalList?.length;
      });
    }
  }
  appraisalFormReset() {
    this.appraisal.appraisal_Date = null;
    this.appraisal.price_guide = null;
    this.appraisal.agent = [];
    this.appraisal.appraisal_status = [];
    this.appraisal.owner = [];
    this.appraisal.lead_source = [];
    this.appraisal.notes = null;
  }
  activeIndex: number = 0;
  activeIndexRight: number = 0;
  showMenu = false;
  selectedIndex: any;
  selectedItem = null;
  menu_items: itemData[] = [
    { id: 1, activeIndex: 0, name: 'Property Details' },
    { id: 2, activeIndex: 1, name: 'Documents' },
    { id: 3, activeIndex: 2, name: 'Tasks' },
    { id: 4, activeIndex: 3, name: 'Appraisals' },
    { id: 5, activeIndex: 4, name: 'Notes' },
  ];

  selectItem(item: any) {
    this.selectedItem = item;
    this.activeIndex = item.activeIndex;
    this.showMenu = false;

    if (item?.name == 'Documents') {
      this.isDocuments = true;
      this.isAppraisal = false;
    } else if (item?.name == 'Appraisals') {
      this.isAppraisal = true;
      this.isDocuments = false;
    } else {
      this.isAppraisal = false;
      this.isDocuments = false;
    }
  }

  itemsHistory: itemData[] = [
    { id: 1, activeIndex: 0, name: 'Listing History' },
    { id: 2, activeIndex: 1, name: 'Property History' },
  ];

  selectedItemHistory: any;
  showMenuHistory = false;
  selectHistory(item: any) {
    this.selectedItemHistory = item;
    this.activeIndexRight = item.activeIndex;
    this.showMenuHistory = false;
  }

  allowOnlyNumberAndDecimal(event: KeyboardEvent) {
    const charCode = event.key;

    // Allow numbers (0-9)
    if (/^[0-9]$/.test(charCode)) {
      return;
    }

    // Allow only one decimal point
    if (charCode === '.') {
      const input = event.target as HTMLInputElement;

      if (input.value.includes('.')) {
        event.preventDefault(); // second decimal block
      }
      return;
    }

    // Block everything else
    event.preventDefault();
  }

  ActivateTabIndexByError(message: string) {
    /**
     * This function takes an error message and parses it to see if it matches a form control name.
     * If it does, it sets the active index to that of the control and scrolls it into view.
     * If the control is a popup modal, it will open the modal.
     * @param message - The error message
     */
    let space_separated: string[] = message?.split(' ');
    if (space_separated?.[0]?.trim()?.length > 0)
      Object.keys(this.controls || {})?.forEach((key: string) => {
        if (key === space_separated?.[0]?.trim()) {
          // Check if the control is a popup modal
          let popupModalFieldsList: string[] = ['building_name', 'unit_no', 'street_no', 'street_name', 'state', 'suburb', 'country'];
          this.activeIndex = this.controls?.[key]?.tabIndex;
          if (popupModalFieldsList.some(value => value === space_separated?.[0]?.trim())) {
            // Open the modal
            const toggleOverlayElement = this.elemRef.nativeElement?.querySelector('#toggle-overlay');
            if (toggleOverlayElement) {
              const clickEvent = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
              });
              toggleOverlayElement.dispatchEvent(clickEvent);
            }
            //  return
          }
          // Scroll the control into view
          setTimeout(() => {
            const element = this.controls?.[key]?.elementRef.nativeElement.querySelector(`[formControlName="${space_separated?.[0]?.trim()}"]`)
              ? this.controls?.[key]?.elementRef.nativeElement.querySelector(`[formControlName="${space_separated?.[0]?.trim()}"]`)
              : this.controls?.[key]?.elementRef.nativeElement.querySelector(`[name="${space_separated?.[0]?.trim()}"]`)
                ? this.controls?.[key]?.elementRef.nativeElement.querySelector(`[name="${space_separated?.[0]?.trim()}"]`)
                : this.controls?.[key]?.elementRef.nativeElement.querySelector(`[id="${space_separated?.[0]?.trim()}"]`);
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 500);
        }
      });
  }

  validateFieldsOnRequest(fields: any[] = []) {
    /**
     * Validates specified fields, sets validators, and updates control validity.
     *
     * @param fields - An array of field error objects to validate.
     */
    if (fields?.length > 0) {
      fields.forEach(field_error => {
        // Rename fields for consistency
        if (field_error.name === 'price') {
          field_error.name = 'value';
        }
        if (field_error.name === 'property_type') {
          field_error.name = 'type';
        }
        // Set required validators on controls
        this.editProperty?.controls?.[field_error?.name]?.setValidators([Validators.required]);
        this.editProperty?.controls?.[field_error?.name]?.updateValueAndValidity();
      });

      // Initialize the error message count
      this.numOfNotValidFields = this.requiredErrorMessages.length = 0;

      // Check for control errors and collect error messages
      for (let prop in this.editProperty.controls) {
        if (this.editProperty.controls[prop].errors) {
          let fieldReqObj = {
            field: prop,
            message: `${fields?.find(tempfile => tempfile.name === prop)?.label || ''}`,
          };
          this.requiredErrorMessages.push(fieldReqObj);
          this.numOfNotValidFields++;
        }
      }

      // Display an error toast if there are any invalid fields
      if (fields.length > 0 && this.numOfNotValidFields === 0) {
        this.toast.error('Check automation fields');
      }
    }
  }
  openAddressOverlayPanel(event) {
    setTimeout(() => {
      this.ops.show(event);
    }, 0);
  }

  propertyAddress: any;
  del_property_id: any;
  deleteThisProperty() {
    this.del_property_id = this.property_id;
    this.propertyAddress = this.editProperty.get('property_address').value;
    this.remmiConfirm
      .delete({ title: 'Delete Property?', message: 'This property will be permanently deleted.', subject: this.propertyAddress })
      .subscribe(isConfirmed => isConfirmed && this.deleteProperty());
  }
  deleteProperty() {
    /**
     * Delete a property
     *
     * This function is invoked when user clicks on the delete button.
     * It sends a delete request to the server and after successfull deletion,
     * it resets the form and hides the right bar.
     */
    this._propertyService.deletePropertyById(this.del_property_id).subscribe({
      /**
       * This callback function is invoked when the server responds with a successfull deletion.
       * It then emits an event to the parent component to rerender the property list.
       * It also resets the form and hides the right bar.
       *
       * @param data The response from the server.
       */
      next: _ => {
        this.isCache = false;
        this.toast.success('Property successfully deleted');
        this.renderPropertyList.emit(true);
        if (this.lmService.tab_levels.length == 1) {
          this.lmService.tab_levels = [];
        }
        this.previousOwner = null;
        this.listingPropertyHistory = null;
        this.allStatus = null;
        this.ownerId = null;
        this.getManualHistory = null;
        this.mergeHistoryArray = null;
        this.lmService.showRightBar = false;
        this.lmService.contact_showRightBar = false;
        this.editProperty.reset();
      },
      error: error => {
        this.toast.error(error.message);
      },
    });
  }

  onUpdateMSelect = (eve: any[], type: string) => {
    let ids = eve?.length > 0 && !['contactBuyer', 'contactSeller'].includes(type) ? eve.map(f => f._id) : null; // More concise way to extract IDs
    if (type === 'owner') {
      this.appraisal.owner = ids || [];
    } else if (type === 'buyer') {
      this.manualHistory.buyer = ids || [];
    } else if (type === 'seller') {
      this.manualHistory.seller = ids || [];
    } else if (type === 'contactBuyer') {
      this.contactBuyer = eve;
    } else if (type === 'contactSeller') {
      this.contactSeller = eve;
    } else {
      this.editProperty.patchValue({ [type]: ids }); // Dynamically set field name
    }
  };
}
